import React from "react";
import Spinner from "@mui/material/CircularProgress";
import queryString from "query-string";
import { withRouter } from "../ContextAndHOC/WithRouter";
import PropTypes from "prop-types";

function formReloader(props) {
  const { location, navigate } = props;
  setTimeout(() => {
    if (location.state) {
      navigate(
        `./${queryString.parse(location.search).reloadTo}/${location.state}`
      );
    } else {
      navigate(`./${queryString.parse(location.search).reloadTo}`);
    }
  }, parseInt(queryString.parse(location.search).timeOut));
  return (
    <div>
      <Spinner />
    </div>
  );
}

formReloader.propTypes = {
  location: PropTypes.object.isRequired,
  navigate: PropTypes.func.isRequired,
};

export default withRouter(formReloader);
